import { render, staticRenderFns } from "./BlockType118.vue?vue&type=template&id=1fcbab06&scoped=true"
import script from "./BlockType118.vue?vue&type=script&lang=ts"
export * from "./BlockType118.vue?vue&type=script&lang=ts"
import style0 from "./BlockType118.vue?vue&type=style&index=0&id=1fcbab06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbab06",
  null
  
)

export default component.exports